import {
	type HostedBadgeValue,
	hostedBadgeAtom,
} from '@client/jotai/storefront/hosted-badge';
import { weddingsHostedCountBadgeAssignmentSelector } from '@client/redux/experiments/selectors/weddings-hosted-count-badge';
import { useAppSelector } from '@redux/hooks';
import { useAtomValue } from 'jotai';

export const useIsWeddingsHostedCountBadgeVariant1Enabled = () => {
	const assignment = useAppSelector(weddingsHostedCountBadgeAssignmentSelector);
	return assignment === 'variant1';
};

export const useIsWeddingsHostedCountBadgeVariant2Enabled = () => {
	const assignment = useAppSelector(weddingsHostedCountBadgeAssignmentSelector);
	return assignment === 'variant2';
};

export const useIsWeddingsHostedCountBadgeEnabled = () => {
	const assignment = useAppSelector(weddingsHostedCountBadgeAssignmentSelector);
	return assignment === 'variant1' || assignment === 'variant2';
};

export const useShouldShowHostedBadge = (): HostedBadgeValue | null => {
	const isEnabled = useIsWeddingsHostedCountBadgeEnabled();
	const hostedBadge = useAtomValue(hostedBadgeAtom);
	return isEnabled ? hostedBadge : null;
};
